import { currencyRepository } from '@webapp/core/data-access/repositories/CurrencyRepository'
import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { GetRequestMileageConfigurationUseCase } from './GetRequestMileageConfigurationUseCase'

export const getRequestMileageConfigurationUseCase =
  new GetRequestMileageConfigurationUseCase({
    expenseRepository,
    currencyRepository,
  })

export { GetRequestMileageConfigurationUseCase } from './GetRequestMileageConfigurationUseCase'
